import { useCallback, useState } from "react";

export interface Props
  extends React.DetailedHTMLProps<
    React.ImgHTMLAttributes<HTMLImageElement>,
    HTMLImageElement
  > {
  fallbackSrc?: string;
  fallbackElement?: JSX.Element | null;
}

const ImageWithFallback = ({
  src,
  fallbackSrc,
  fallbackElement,
  ...otherProps
}: Props): JSX.Element | null => {
  const [loadingFailed, setLoadingFailed] = useState(false);

  const handleError = useCallback(() => {
    setLoadingFailed(true);
  }, []);

  if (loadingFailed && !fallbackSrc && fallbackElement !== undefined) {
    return fallbackElement;
  }

  return (
    <img
      src={
        loadingFailed
          ? fallbackSrc
          : `${process.env.NEXT_PUBLIC_HOST_URL}${src}`
      }
      onError={handleError}
      {...otherProps}
    />
  );
};

export default ImageWithFallback;
